import { useTranslation } from 'react-i18next';



export const Video = () => {
	const { t } = useTranslation([ 'web', 'links' ]);

	return (
		<div className='video-wrapper'>
			<iframe
				src={t('video.dogsVideo', { ns: 'links' })}
				title={t('pages.home.dogs.advantages.videoTitle')}
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowFullScreen />
		</div>
	);
};